import React from 'react';
import { Text, View } from 'react-native';
import { AgeRatingDefinition, AgeRatingDefinitions, AgeRatingKey } from 'utils/ageRating';
import { calcSizeForDevice } from 'utils/index';

type RatingProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  customAppendix?: string;
  ageRatingKey: AgeRatingKey;
  append?: keyof Omit<AgeRatingDefinition, 'badge'> | 'custom';
};

const SIZE_MAP = {
  xs: {
    box: 22,
    font: 10,
    appendFont: 10,
  },
  sm: {
    box: 26,
    font: 12,
    appendFont: 12,
  },
  md: {
    box: 36,
    font: 16,
    appendFont: 16,
  },
  lg: {
    box: 45,
    font: 16,
    appendFont: 16,
  },
};

const Rating: React.FC<RatingProps> = ({ ageRatingKey, append, customAppendix, size = 'sm' }) => {
  const definition = AgeRatingDefinitions[ageRatingKey];
  const appendValue = append && (append === 'custom' ? customAppendix : definition[append]);

  const currentSize = SIZE_MAP[size];

  if (ageRatingKey === 'SC') {
    return (
      <View
        style={{
          borderRadius: 4,
          alignItems: 'center',
          justifyContent: 'center',
          width: calcSizeForDevice(currentSize.box),
          height: calcSizeForDevice(currentSize.box),
        }}
      />
    );
  }

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: calcSizeForDevice(10) }}>
      <View
        style={{
          borderRadius: 4,
          alignItems: 'center',
          justifyContent: 'center',
          width: calcSizeForDevice(currentSize.box),
          height: calcSizeForDevice(currentSize.box),
          backgroundColor: definition?.badge?.color,
        }}>
        <Text
          style={{
            fontFamily: 'system-ui',
            lineHeight: 22,
            color: 'white',
            fontSize: calcSizeForDevice(currentSize.font),
            fontWeight: 'bold',
          }}>
          {definition?.badge?.label}
        </Text>
      </View>

      {appendValue && (
        <Text
          style={{
            fontFamily: 'system-ui',
            lineHeight: 22,
            color: 'white',
            fontSize: calcSizeForDevice(currentSize.appendFont),
          }}>
          {appendValue}
        </Text>
      )}
    </View>
  );
};

export default Rating;
